import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import DashboardLayout from '../components/DashboardLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { MessageSquare, AlertTriangle, Radio } from 'lucide-react';
import LoungeDiscussions from '../components/community/LoungeDiscussions';
import ProviderAlerts from '../components/community/ProviderAlerts';
import LiveChat from '../components/community/LiveChat';

export default function LoungePage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('discussions');

  // Check if provider is active
  if (user?.accountStatus !== 'ACTIVE') {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <AlertTriangle className="h-12 w-12 mx-auto text-yellow-500 mb-4" />
            <h2 className="text-xl font-semibold mb-2">Access Restricted</h2>
            <p className="text-muted-foreground">
              Only active providers can access the Provider Lounge.
            </p>
          </div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold">Provider Lounge</h1>
          <p className="text-muted-foreground">Connect with other providers in your community</p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-3 max-w-md">
            <TabsTrigger value="discussions" className="flex items-center gap-2" data-testid="tab-discussions">
              <MessageSquare className="h-4 w-4" />
              <span className="hidden sm:inline">Discussions</span>
            </TabsTrigger>
            <TabsTrigger value="chat" className="flex items-center gap-2" data-testid="tab-live-chat">
              <Radio className="h-4 w-4" />
              <span className="hidden sm:inline">Live Chat</span>
            </TabsTrigger>
            <TabsTrigger value="alerts" className="flex items-center gap-2" data-testid="tab-alerts">
              <AlertTriangle className="h-4 w-4" />
              <span className="hidden sm:inline">Alerts</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="discussions" className="mt-6">
            <LoungeDiscussions />
          </TabsContent>

          <TabsContent value="chat" className="mt-6">
            <LiveChat />
          </TabsContent>

          <TabsContent value="alerts" className="mt-6">
            <ProviderAlerts />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
}
